import { cardTypeDtoToEntity } from "src/app/features/CardType/services/mappers/CardTypeDtoToEntity";
import type { CardTypeDto } from "src/app/features/CardType/types/CardTypeDto";
import type { CardTypeEntity } from "src/app/features/CardType/types/CardTypeEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const CardTypeTableDtoMapper = (input: Readonly<ResourcePageDto<CardTypeDto>>): ResourcePageEntity<CardTypeEntity> => {
    return {
        list: input.list ? input.list.map(cardTypeDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
